import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobScheduleResponse } from '../../../models/Table';
import moment from 'moment';
import 'moment-timezone';
import { RestService } from 'src/app/rest.service';
import { catchError } from 'rxjs/operators';
import { TimeZoneUtils } from 'src/app/utils/timezone.utils';
import { SchedulerUtils } from 'src/app/utils/scheduler.utils';

@Component({
  selector: 'app-schedule-edit-job',
  templateUrl: './schedule-edit-job.component.html',
  styleUrls: ['./schedule-edit-job.component.css']
})
export class ScheduleEditJobComponent implements OnInit {

  selectedTimeZone: string = "";
  localTimeZone: string = "";
  
  isReviewDateShown: boolean = false;
  isReviewTimeShown: boolean = false;

  disableIncreaseHours: boolean;
  disableDecreaseHours: boolean;

  disableIncreaseMinutes: boolean;
  disableDecreaseMinutes: boolean;

  isSmartMatchChecked: boolean;

  editMachineId: any;
  machineId: any = "";
  hours: any;
  minutes: any;

  isLoadingIcon = false;
  isDifferentTimezone = true;
  isFailure = false;
  failureMessage = '';

  isSuccess = false;
  successMessage = '';

  expandRowId: any;
  
  estHours: any;
  estMintues: any;
  estEditHours: any;
  estEditMintues: any;
  estEditHoursSelection: any = 0;
  estEditMinuteSelection: any = 0;

  startDate: any = "";
  tphours: any = "00";
  tshours:any = '00';
  tsminutes:any="00";
  tpminutes: any = "00";
  tptype: any = "AM";

  tableobj: any;
  headerobj: any;
  machineobj: any;

  occID: any;

  @Input() environment;
  @Input() job;
  @Input() jobDescription;
  @Input() masterEnvId;
  @Input() startType;
  @Input() estHoursSelection;
  @Input() estMinuteSelection;
  @Input() isSeries = false;
  @Input() isEdit = false;
  @Input() runNow = false;
  @Input() jobScheduleResponse: JobScheduleResponse;

  @Input() seriesInp;
  @Input() repeatType;
  @Input() saveFrequency = false;

  @Output() onSave = new EventEmitter<any>();

  constructor(private _restService: RestService) { }

  ngOnInit() {
    this.selectedTimeZone = localStorage.getItem('selectedTimeZone');
    this.localTimeZone = localStorage.getItem('localTimeZone');

    this.estHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estMintues = Array(60)
      .fill(0)
      .map((x, i) => i);

    this.estEditHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estEditMintues = Array(60)
      .fill(0)
      .map((x, i) => i);
  }

  reviewDateEvent(){
    this.isReviewDateShown = !this.isReviewDateShown;
    this.isReviewTimeShown = false;
  }

  increaseHours(){
    var hrs = parseInt(this.tphours) + 1;
    this.disableDecreaseHours = false;
    if (hrs >= 12) {
      this.tphours = 12;
      this.disableIncreaseHours = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHours = false;
    }
  }

  decreaseHours(){
    var hrs = parseInt(this.tphours) - 1;
    this.disableIncreaseHours = false;
    if (hrs <= 0) {
      this.tphours = "00";
      this.disableDecreaseHours = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHours = false;
    }
  }

  increaseMinutes() {
    var mins = parseInt(this.tpminutes) + 1;
    this.disableDecreaseMinutes = false;
    if (mins > 59) {
      this.disableIncreaseMinutes = true;
    } else {
      this.disableIncreaseMinutes = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMinutes() {
    var mins = parseInt(this.tpminutes);
    this.disableIncreaseMinutes = false;
    if (mins === 0) {
      this.disableDecreaseMinutes = true;
      this.tpminutes = "00";
    } else {
      mins = parseInt(this.tpminutes) - 1;
      this.disableDecreaseMinutes = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  reviewTimeEvent(rowId: number){
    this.isReviewTimeShown = !this.isReviewTimeShown;
    this.isReviewDateShown = false;
  }

  save(){
    if (this.isEdit){
      if (!this.isSeries){
        this.editJob();
      }else{
        this.editSeriesJob();
      }
      return;
    }

    if (!this.isSeries){
      this.saveSingle();
    }else{
      this.saveRec();
    }
  }

  editSeriesJob(){
    this.isLoadingIcon = true;

    this.jobScheduleResponse.scheduleListRes.OccuranceTable.filter(
      (p: any) => (delete p.MaintanceListArr, delete p.scheduleArr)
    );

    this.jobScheduleResponse.scheduleListRes.OccuranceTable.filter((m:any) =>(
      m.OccuranceId = m.OccuranceId || m.occuranceId,
      m.NewStart = TimeZoneUtils.inverseTimezoneConvert(m.NewStart),
      m.NewEnd = TimeZoneUtils.inverseTimezoneConvert(m.NewEnd),
      m.NewStart = new Date(m.NewStart).toISOString(),
      m.NewEnd = new Date(m.NewEnd).toISOString()
    )
    )

    this.jobScheduleResponse.scheduleListRes.OccuranceTable.filter((f: any) =>
      f.OccuranceId == this.occID
        ? (f.jobDuration = {
          hours: this.estEditHoursSelection,
          minutes: this.estEditMinuteSelection,
        })
        : ""
    );

    console.log("Edit Series");
    console.log(this.jobScheduleResponse);

    this._restService
      .editSeriesOccurance(
        this.environment,
        this.jobScheduleResponse.scheduleListRes.Header,
        this.jobScheduleResponse.scheduleListRes.OccuranceTable,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Result", f),
          this.onSave.emit(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          (this.isLoadingIcon = false)
        )
      );
  }

  editJob(){
    //this.isEditOccShown = false;
    this.isLoadingIcon = true;

    const occurrenceResult = this.jobScheduleResponse.scheduleListRes;
    //console.log("Occ Result --->", this.occurrenceResult);
    let Header = occurrenceResult.Header;
    let flaggedMid = (Header as any).flaggedMid !== undefined ? (Header as any).flaggedMid : [];
    let OccuranceTable = occurrenceResult.OccuranceTable;

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

      let start = new Date(OccuranceTable[0].NewStart);
      console.log("occurance table--->", start);
      

    this._restService
      .editOccurance(
        this.occID,
        this.environment,
        Header.description,
        TimeZoneUtils.inverseTimezoneConvert(OccuranceTable[0].NewStart),
        TimeZoneUtils.inverseTimezoneConvert(OccuranceTable[0].NewEnd),
        this.job,
        Header.MachineId,
        OccuranceTable[0].Status,
        OccuranceTable[0].flagged,
        Header.jobDuration,
        flaggedMid,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("f", f),
          this.onSave.emit(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo)
        )
      );
  }

  saveRec(){
    this.isLoadingIcon = true;
    var occ = [];
    var count = 0;

    this.tableobj = this.jobScheduleResponse.scheduleListRes.OccuranceTable;
    var t = this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) =>
          d.IsNew === true
            ? ((d.Status = m.Status), (d.flagged = m.flagged))
            : ""
        )
        : ""
    );

    this.tableobj.filter((m: any, index: any) =>
      index === 0
        ? m.machineId === null || m.machineId === undefined
          ? (this.machineId = m.MachineId)
          : (this.machineId = m.machineId)
        : ""
    );

    console.log("machineId ------------->>>", this.machineId);
    console.log("Mid 1 ------------->>>", this.tableobj);

    this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) => {

          d.IsNew === true ? occ.push(d) : "";
          d.startDate = moment(d.startDate).format('YYYY-MM-DD HH:mm:ss');
          d.endDate = moment(d.endDate).format('YYYY-MM-DD HH:mm:ss');
        }
        )
        : ""
    );

    var startDate = "";
    var endDate = "";

    occ.filter((f: any, i: any) =>
      i === 0
        ? ((startDate = f.startDate), console.log("s---------->", f.startDate))
        : ""
    );

    occ.filter((f: any, i: any) =>
      i === occ.length - 1
        ? ((endDate = f.endDate), console.log("s---------->", f.endDate))
        : ""
    );

    console.log("occurance", occ);
    this.isLoadingIcon = false;

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString())
      )
    );

    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage = "Job(s) creating date can not be duplicate"))
      : "";

    count === 0
      ? this._restService
        .saveRecJobSchedule(
          this.environment,
          this.job,
          this.seriesInp,
          this.jobDescription,
          this.repeatType,
          this.estHoursSelection,
          this.estMinuteSelection,
          this.saveFrequency,
          this.machineId,
          startDate,
          endDate,
          occ,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("Save Job Schedule", f),
            (this.isSuccess = true),
            (this.successMessage = f.response),
              (this.isLoadingIcon = false),
              this.onSave.emit()
          )
        )
      : "";
  }

  saveSingle(){
    console.log("entry");

    this.isLoadingIcon = true;
    var occ = [];
    var count = 0;
    var findDuplicates: any = [];

    this.tableobj = this.jobScheduleResponse.scheduleListRes.OccuranceTable;

    var t = this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) => {
          d.IsNew === true
            ? ((d.machineId = m.machineId),
              (d.Status = m.Status),
              (d.flagged = m.flagged))
            : "";
            d.startDate = moment(d.startDate).format('YYYY-MM-DD HH:mm:ss');
            d.endDate = moment(d.endDate).format('YYYY-MM-DD HH:mm:ss');
          }
        )
        : ""
    );

    this.tableobj.filter((m: any) =>
      m.hasOwnProperty("flaggedMid")
        ? m.hasOwnProperty("scheduleArr")
          ? m.scheduleArr.filter((d: any) => (d.flaggedMid = m.flaggedMid))
          : ""
        : ""
    );

    console.log("FlaggedMID 2", this.tableobj);

    this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) =>
          d.IsNew === true ? occ.push(d) : ""
        )
        : ""
    );
    console.log("TableObj ------->>>>>>", this.tableobj);
    console.log("occurance ------->>>>>>", occ);

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (

        (f.start = (

          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString()),
        (console.log(JSON.stringify(f)))
      )
    );

    console.log("occurance ------->>>>>>", this.tableobj);

    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];
    console.log("unique------", unique);
    

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage = "Job(s) creating date can not be duplicate"))
      : "";

    

    count === 0
      ? this._restService
        .saveJobSchedule(
          this.environment,
          this.jobDescription,
          this.runNow ? 0 : this.startType,
          this.estHoursSelection,
          this.estMinuteSelection,
          occ,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            this.jobScheduleResponse = f,
            console.log("Save Job Schedule", f),
            (this.isSuccess = true),
            ((this.successMessage = f.response),
              (this.isLoadingIcon = false)),
            this.onSave.emit()
          )
        )
      : "";

  }

  closeDate(){
    var d = localStorage.getItem("cancelDate");
    this.startDate = d.split("/").reverse().join("-");
    localStorage.setItem("singleDate", d);
    localStorage.setItem('mSingleDate',d);
    this.isReviewDateShown = false;
  }

  applyDate(){
    var d = localStorage.getItem("singleDate");
    this.startDate = d.split("/").reverse().join("-");

    const tableobj = this.jobScheduleResponse.scheduleListRes.OccuranceTable;

    tableobj.map(
      (f: any) => (
        console.log(f.NewStart + "---" + this.startDate + "---" + d),
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString())
      )
    );

    // To do failure modal

    /*tableobj.map((f: any) =>
      f.rowid !== this.expandRowId
        ? f.start === this.startDate
          ? ((this.isFailure = true),
            (this.failureMessage = "Selected date is already exists"))
          : ""
        : ""
    );*/

    console.log("Dates -->", tableobj);

    localStorage.setItem("singleDate", d);
    localStorage.setItem("cancelDate", d);
    localStorage.setItem("mSingleDate", d);
    //this.isRangeStartShown = false;
    this.isReviewDateShown = false;
  }

  closeTime(){
    this.isReviewTimeShown = false;
  }

  changetimeformat(){
    var f = this.tptype;
    f === "AM" ? (this.tptype = "PM") : (this.tptype = "AM");
  }

  estEditMinutesEvent(event: any){
    var mins = parseInt(event.target.value);
    var hrs = this.estEditHoursSelection;
  }

  estEditHoursEvent(event: any){
    var hrs = parseInt(event.target.value);
    if (hrs === 24) {
      this.estEditMinuteSelection = 0;
      this.estEditMintues = Array(1)
        .fill(0)
        .map((x, i) => i);
    } else {
      this.estEditMintues = Array(60)
        .fill(0)
        .map((x, i) => i);
    }
  }

  onChangeMachine(event: any){
    this.machineId = event.target.value;
    this.editMachineId = event.target.value;
    //this.isMachineIdInvalid = false;
    this.isSmartMatchChecked = false;
  }

  updateSchedule(id: any) {
    this.isLoadingIcon = true;
    var count = 0;

    var ty = this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;

    var t = this.jobScheduleResponse.scheduleListRes.OccuranceTable;

    t.filter((f: any) => {
      f.rowid === id
        ? (f.NewStart = (
          new Date(this.startDate).getFullYear() +
          "-" +
          (new Date(this.startDate).getMonth() + 1) +
          "-" +
          new Date(this.startDate).getDate() +
          " " +
          ty +
          ":" +
          this.tpminutes +
          ":" +
          "00"
        ).toString())
        : ""
    });

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    t.map(
      (f: any) =>
      (f.start = (
        new Date(f.NewStart).getFullYear() +
        "-" +
        (new Date(f.NewStart).getMonth() + 1) +
        "-" +
        new Date(f.NewStart).getDate()
      ).toString())
    );

    t.map((f: any) =>
      f.rowid !== this.expandRowId
        ? f.start === d
          ? ((this.isLoadingIcon = false),
            (count = count + 1),
            (this.isFailure = true),
            (this.failureMessage = "Selected date is already exists"))
          : ""
        : ""
    );


    t = t;
    const editedStartDateArray = [];
    // this.editedStartDateArray.push((this.startDate));
    // this.estHoursSelection = this.estEditHoursSelection;

    console.log("Edit and occID");
    console.log(this.isEdit);
    console.log(this.occID);
    

    t.filter((f: any) => editedStartDateArray.push(f.NewStart));
    console.log("tttttt---->", t);

    count === 0
      ? this.estEditHoursSelection === "0" &&
        this.estEditMinuteSelection === "0"
        ? ((this.isLoadingIcon = false),
          (this.isFailure = true),
          (this.failureMessage = "Estimated duration time is required"))
        : this._restService
          .createJobSchedule(
            this.environment,
            this.job,
            this.jobDescription,
            3,
            editedStartDateArray,
            this.editMachineId,
            this.estEditHoursSelection,
            this.estEditMinuteSelection,
            false,
            this.isEdit,
            this.isEdit ? this.occID : 0,
            this.masterEnvId
          )
          .pipe(
            catchError((e) => {
              (this.isLoadingIcon = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.response
                  ? e.error.response
                  : e.error.StatusInfo);
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              (this.isSeries ?
              this.jobScheduleResponse.scheduleListRes.OccuranceTable = f.scheduleListRes.OccuranceTable :
              this.jobScheduleResponse = f),
              (this.tableobj = []),
              (this.headerobj = this.jobScheduleResponse.scheduleListRes.Header),
              (this.machineobj = this.jobScheduleResponse.scheduleListRes.machineList),
              (this.tableobj = this.jobScheduleResponse.scheduleListRes.OccuranceTable),
              this.tableobj.filter((m: any) => (m.isfold = false)),
              this.tableobj.filter(
                (m: any, index: any) => (m.rowid = index + 1)
              ),
              this.tableobj.filter(
                (m: any, index: any) => (
                  (m.startDateBefore = (m.NewStart)),
                  (m.endDateBefore = (m.NewEnd)),
                  (m.NewStart = this.timezoneConvert(m.NewStart)),
                  (m.NewEnd = this.timezoneConvert(m.NewEnd)),

                  console.log("end 12", JSON.stringify(m.startDateBefore))
                ),
              ),
              console.log("table 1", this.tableobj),
              this.tableobj.filter((m: any) =>
                SchedulerUtils.updateScheduleObject(m)
              ),
              console.log("table 2", this.tableobj),
              (this.isLoadingIcon = false)
            )
          )
      : "";
  }

  cancelSchedule(id: any) {
    var t = this.jobScheduleResponse.scheduleListRes.OccuranceTable;
    t.filter((f: any) =>
      f.rowid === id
        ? f.isfold === true
          ? (f.isfold = false)
          : (f.isfold = true)
        : ""
    );
  }

  resetSchedule(id: any) {
    this.chartExpandEvent(id);
  }

  chartExpandEvent(id: any) {
    console.log(this.jobScheduleResponse.scheduleListRes.OccuranceTable);
    console.log(this.isSeries);

    console.log(this.occID);
    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;
    var col = this.jobScheduleResponse.scheduleListRes.OccuranceTable;
    this.expandRowId = id;

    console.log(col);
    console.log(id);
    col.forEach(f => {
      if (f.rowid == parseInt(id)){
        this.occID =  (f as any).OccuranceId || (f as any).occuranceId
      }
    })

    console.log(this.occID);

    col.filter((f: any) =>
      parseInt(f.rowid) === parseInt(id)
        ? f.isfold === false
          ? (f.isfold = true)
          : (f.isfold = false)
        : (f.isfold = false)
    );

    col.filter((f: any) =>
      f.rowid === id
        ? (this.isSeries
          ? (this.editMachineId = f.machineId || f.MachineId)
          : (this.editMachineId = f.machineId),
          (this.startDate = f.NewStart),
          this.occID = (f as any).OccuranceId || (f as any).occuranceId,
          localStorage.setItem(
            "cancelDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "singleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          )
          )
        : ""
    );

    col.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.NewStart).getHours() > 12
          ? (new Date(f.NewStart).getHours() - 12).toString().length > 1
            ? (this.tphours = new Date(f.NewStart).getHours() - 12)
            : (this.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
          : new Date(f.NewStart).getHours() === 12
            ? (this.tphours = new Date(f.NewStart).getHours())
            : new Date(f.NewStart).getHours() < 12
              ? new Date(f.NewStart).getHours().toString().length > 1
                ? (this.tphours = new Date(f.NewStart).getHours())
                : (this.tphours = "0" + new Date(f.NewStart).getHours())
              : "",
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          new Date(f.NewStart).getHours() >= 12
            ? (this.tptype = "PM")
            : new Date(f.NewStart).getHours() < 12
              ? (this.tptype = "AM")
              : "")
        : ""
    );

    col.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.startDateBefore).getHours() > 12
          ? (new Date(f.startDateBefore).getHours() - 12).toString().length > 1
            ? (this.tshours = new Date(f.startDateBefore).getHours() - 12)
            : (this.tshours = "0" + (new Date(f.startDateBefore).getHours() - 12))
          : new Date(f.startDateBefore).getHours() === 12
            ? (this.tshours = new Date(f.startDateBefore).getHours())
            : new Date(f.startDateBefore).getHours() < 12
              ? new Date(f.startDateBefore).getHours().toString().length > 1
                ? (this.tshours = new Date(f.startDateBefore).getHours())
                : (this.tshours = "0" + new Date(f.startDateBefore).getHours())
              : "",
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          new Date(f.NewStart).getHours() >= 12
            ? (this.tptype = "PM")
            : new Date(f.NewStart).getHours() < 12
              ? (this.tptype = "AM")
              : "")
        : ""
    );

    const headerobj = this.jobScheduleResponse.scheduleListRes.Header;

    let duration = [];
    console.log(headerobj);
    headerobj.hasOwnProperty("duration")
      ? (duration = headerobj["duration"].split(":"))
      : "";
    this.headerobj = headerobj;
    console.log("tshours --->", this.tshours);

    const tbl = col.find(c => c.rowid === id) as any;

    console.log(tbl);
    console.log(this.headerobj);

    if(tbl && tbl.duration){
      this.estEditHoursSelection = parseInt(tbl.duration[0]);
      this.estEditMinuteSelection = parseInt(tbl.duration[1]);
    } else if(tbl && tbl.jobDuration){
      this.estEditHoursSelection =tbl.jobDuration.split(":");
      this.estEditHoursSelection = parseInt(this.estEditHoursSelection[0]);
      this.estEditMinuteSelection = tbl.jobDuration.split(':');
      this.estEditMinuteSelection = parseInt(this.estEditMinuteSelection[1]);
      // this.estEditMinuteSelection = parseInt(tbl.duration[1]);
    } else if(this.headerobj.jobDuration){
      this.estEditHoursSelection = this.headerobj.jobDuration.hours;
      this.estEditHoursSelection = parseInt(this.estEditHoursSelection);
      this.estEditMinuteSelection = this.headerobj.jobDuration.minutes;
      this.estEditMinuteSelection = parseInt(this.estEditMinuteSelection);
    } else if(this.headerobj.duration){
      var dur = this.headerobj.duration.split(':');
      this.estEditHoursSelection = parseInt(dur[0]);
      this.estEditMinuteSelection = parseInt(dur[1]);
    }else{
      headerobj.hasOwnProperty("jobDuration")
      ? (this.estEditHoursSelection = headerobj.jobDuration.hours)
      : (this.estEditHoursSelection = parseInt(duration[0]));

      headerobj.hasOwnProperty("jobDuration")
        ? (this.estEditMinuteSelection = headerobj.jobDuration.minutes)
        : (this.estEditMinuteSelection = parseInt(duration[1]));
    }
  }

  timezoneConvert(dt) {
    console.log("entry--->", dt)
    const d = new Date(dt);
    var timeZoneFromDB: any = localStorage.getItem('timezoneName');
    let timezone = moment.tz(d, timeZoneFromDB).format("YYYY-MM-DD HH:mm:ss");
    return timezone;
  }

  sortSchedule(scheduleArr){
    (scheduleArr as any []).sort((a, b) => {
      const ascore = a.IsNew ? 1 : 0;
      const bscore = b.IsNew ? 1 : 0;

      return ascore - bscore;
    });

    return scheduleArr;
  }
}
